import apiClient from '../client';
import { API_ENDPOINTS } from '../endpoints';
import type {
  ProjectFilters,
  UpdateProjectRequest,
  ProjectResponse,
  ProjectsResponse,
} from '../types';

export const adminProjectService = {
  // Get all client projects
  getProjects: async (filters?: ProjectFilters): Promise<ProjectsResponse> => {
    const paramsWithSort = {
      ...filters,
      sort_by: filters?.sort_by || 'created_at',
      sort_order: filters?.sort_order || 'desc',
    };

    const response = await apiClient.get<ProjectsResponse>(
      API_ENDPOINTS.ADMIN.CLIENT_PROJECTS,
      { params: paramsWithSort }
    );

    return response.data;
  },

  // Get single client project
  getProject: async (id: number): Promise<ProjectResponse> => {
    const response = await apiClient.get<ProjectResponse>(
      API_ENDPOINTS.ADMIN.CLIENT_PROJECT_DETAIL(id)
    );

    return response.data;
  },

  // Update client project
  updateProject: async (
    id: number,
    data: UpdateProjectRequest | FormData
  ): Promise<ProjectResponse> => {
    const isFormData = data instanceof FormData;

    if (isFormData) {
      const response = await apiClient.post<ProjectResponse>(
        API_ENDPOINTS.ADMIN.CLIENT_PROJECT_UPDATE_WITH_FILES(id),
        data,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    }

    const response = await apiClient.put<ProjectResponse>(
      API_ENDPOINTS.ADMIN.CLIENT_PROJECT_DETAIL(id),
      data
    );

    return response.data;
  },

  // Delete client project
  deleteProject: async (id: number): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.ADMIN.CLIENT_PROJECT_DETAIL(id));
  },

  // Update project status (approve/reject)
  updateStatus: async (
    id: number,
    status: 'pending' | 'approved' | 'rejected'
  ): Promise<ProjectResponse> => {
    const response = await apiClient.post<ProjectResponse>(
      API_ENDPOINTS.ADMIN.CLIENT_PROJECT_STATUS(id),
      { status }
    );

    return response.data;
  },
};
